import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderT from "./HeaderT";
import FooterB from "./FooterB";
import { useNavigate } from "react-router-dom";
import { fetchAssignedOrders, updateOrderStatus } from "../../features/orders/orderSlice";

const S = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
  .dbo-root { font-family:'Inter',sans-serif; background:#f8fafc; min-height:100vh; padding-bottom:90px; }
  .dbo-header-bar { padding:20px 16px 10px; border-bottom:1px solid #e2e8f0; background:#fff; sticky:top; }
  .dbo-header-bar h1 { font-size:20px; font-weight:900; color:#0f172a; margin:0 0 4px; }
  .dbo-header-bar p { font-size:13px; color:#94a3b8; margin:0; }

  .dbo-filter-row { display:flex; gap:8px; padding:14px 16px; overflow-x:auto; scrollbar-width:none; }
  .dbo-filter-row::-webkit-scrollbar { display:none; }
  .dbo-filter-btn {
    padding:7px 16px; border-radius:100px; font-size:12px; font-weight:800;
    border:1.5px solid #e2e8f0; background:#fff; color:#64748b; cursor:pointer;
    white-space:nowrap; font-family:'Inter',sans-serif; transition:all 0.2s; flex-shrink:0;
  }
  .dbo-filter-btn.active { background:#14b8a6; border-color:#14b8a6; color:#fff; }

  .dbo-list { padding:10px 16px; }

  .dbo-card {
    background:#fff; border:1.5px solid #e2e8f0; border-radius:20px;
    margin-bottom:14px; overflow:hidden;
    box-shadow:0 2px 10px rgba(0,0,0,0.05); transition:all 0.25s;
  }
  .dbo-card:hover { box-shadow:0 8px 28px rgba(0,0,0,0.1); }
  .dbo-card-head {
    padding:14px 18px; border-bottom:1px solid #f1f5f9;
    display:flex; align-items:center; justify-content:space-between;
    background:linear-gradient(90deg,#f8fafc,#fff);
  }
  .dbo-order-no { font-size:14px; font-weight:800; color:#0f172a; }
  .dbo-order-date { font-size:11px; color:#94a3b8; font-weight:600; margin-top:2px; }

  .dbo-card-body { padding:16px 18px; }
  .dbo-detail-row { display:flex; align-items:flex-start; gap:10px; margin-bottom:10px; }
  .dbo-detail-row:last-child { margin:0; }
  .dbo-detail-icon { font-size:16px; width:24px; text-align:center; flex-shrink:0; margin-top:1px; }
  .dbo-detail-label { font-size:11px; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:0.06em; }
  .dbo-detail-val { font-size:13px; font-weight:600; color:#0f172a; margin-top:1px; }
  .dbo-detail-val a { color:#14b8a6; }

  .dbo-items-list { margin-top:8px; }
  .dbo-item-chip {
    display:inline-flex; align-items:center; gap:6px; padding:4px 12px;
    background:#f0fdfa; border:1px solid #a7f3d0; border-radius:100px;
    font-size:12px; font-weight:700; color:#0d9488; margin:4px 4px 0 0;
  }

  .dbo-card-footer { padding:12px 18px; border-top:1px solid #f1f5f9; display:flex; gap:10px; background:#fafafa; }
  .dbo-btn {
    flex:1; padding:11px; border:none; border-radius:12px;
    font-size:13px; font-weight:800; font-family:'Inter',sans-serif;
    cursor:pointer; transition:all 0.2s;
  }
  .dbo-btn-primary { background:#14b8a6; color:#fff; box-shadow:0 4px 14px rgba(20,184,166,0.35); }
  .dbo-btn-primary:hover { background:#0d9488; }
  .dbo-btn-success { background:#22c55e; color:#fff; box-shadow:0 4px 14px rgba(34,197,94,0.35); }
  .dbo-btn-success:hover { background:#16a34a; }
  .dbo-btn-ghost { background:#fff; color:#475569; border:1.5px solid #e2e8f0; }
  .dbo-btn-ghost:hover { background:#f1f5f9; }

  .dbo-pill {
    display:inline-flex; padding:3px 12px; border-radius:100px;
    font-size:11px; font-weight:800; text-transform:uppercase; letter-spacing:0.06em;
  }
  .dbo-pill-assigned  { background:#fff7ed; color:#c2410c; border:1px solid #fed7aa; }
  .dbo-pill-active    { background:#eff6ff; color:#1d4ed8; border:1px solid #bfdbfe; }
  .dbo-pill-delivered { background:#f0fdf4; color:#15803d; border:1px solid #bbf7d0; }

  .dbo-empty { text-align:center; padding:64px 24px; }
  .dbo-empty-ico { font-size:52px; margin-bottom:14px; }
  .dbo-empty-title { font-size:17px; font-weight:800; color:#0f172a; }
  .dbo-empty-sub { font-size:13px; color:#94a3b8; margin-top:6px; }

  .dbo-skel { background:linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%);
    background-size:200% 100%; animation:dboSkel 1.4s ease infinite; border-radius:14px; }
  @keyframes dboSkel{0%{background-position:200% 0}100%{background-position:-200% 0}}
`;

const statusPill = (status) => {
  const map = {
    assigned:  { cls: "dbo-pill-assigned",  label: "⏳ Pending" },
    active:    { cls: "dbo-pill-active",     label: "🚛 On Route" },
    delivered: { cls: "dbo-pill-delivered",  label: "✅ Delivered" },
  };
  const s = map[status] || { cls: "dbo-pill-assigned", label: status };
  return <span className={`dbo-pill ${s.cls}`}>{s.label}</span>;
};

const Orders = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intervalRef = useRef(null);
  const [filter, setFilter] = useState("all");
  const [confirmId, setConfirmId] = useState(null);

  const { user }  = useSelector((s) => s.auth);
  const { orders, isLoading } = useSelector((s) => s.orders);
  const deliveryPersonId = user?._id;

  useEffect(() => {
    if (!user) { navigate("/"); return; }
    if (deliveryPersonId) {
      dispatch(fetchAssignedOrders(deliveryPersonId));
      intervalRef.current = setInterval(() => {
        dispatch(fetchAssignedOrders(deliveryPersonId));
      }, 15000);
    }
    return () => clearInterval(intervalRef.current);
  }, [dispatch, deliveryPersonId, user, navigate]);

  const handleAccept = async (orderId) => {
    await dispatch(updateOrderStatus({ orderId, status: "active" }));
    dispatch(fetchAssignedOrders(deliveryPersonId));
  };

  const handleDeliver = async (orderId) => {
    if (confirmId === orderId) {
      await dispatch(updateOrderStatus({ orderId, status: "delivered" }));
      dispatch(fetchAssignedOrders(deliveryPersonId));
      setConfirmId(null);
    } else {
      setConfirmId(orderId);
      setTimeout(() => setConfirmId(null), 3000);
    }
  };

  const filtered = (orders || []).filter((o) => {
    if (filter === "all")       return o.orderStatus !== "delivered";
    if (filter === "pending")   return o.orderStatus === "assigned";
    if (filter === "active")    return o.orderStatus === "active";
    if (filter === "delivered") return o.orderStatus === "delivered";
    return true;
  });

  const counts = {
    all:       (orders || []).filter((o) => o.orderStatus !== "delivered").length,
    pending:   (orders || []).filter((o) => o.orderStatus === "assigned").length,
    active:    (orders || []).filter((o) => o.orderStatus === "active").length,
    delivered: (orders || []).filter((o) => o.orderStatus === "delivered").length,
  };

  return (
    <>
      <style>{S}</style>
      <div className="dbo-root">
        <HeaderT />

        <div className="dbo-header-bar">
          <h1>Assigned Orders 📦</h1>
          <p>Your deliveries — updates every 15 seconds</p>
        </div>

        {/* ── Filters ── */}
        <div className="dbo-filter-row">
          {[
            { id: "all",       label: `All (${counts.all})` },
            { id: "pending",   label: `⏳ Pending (${counts.pending})` },
            { id: "active",    label: `🚛 Active (${counts.active})` },
            { id: "delivered", label: `✅ Done (${counts.delivered})` },
          ].map((f) => (
            <button
              key={f.id}
              className={`dbo-filter-btn${filter === f.id ? " active" : ""}`}
              onClick={() => setFilter(f.id)}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* ── Cards ── */}
        <div className="dbo-list">
          {isLoading ? (
            [1,2,3].map((i) => <div key={i} className="dbo-skel" style={{ height: 180, marginBottom: 14 }} />)
          ) : filtered.length === 0 ? (
            <div className="dbo-empty">
              <div className="dbo-empty-ico">{filter === "delivered" ? "🎉" : "📋"}</div>
              <div className="dbo-empty-title">
                {filter === "delivered" ? "No deliveries completed yet" : "No orders here"}
              </div>
              <div className="dbo-empty-sub">
                {filter === "delivered" ? "Completed deliveries will appear here" : "New orders will appear automatically"}
              </div>
            </div>
          ) : (
            filtered.map((order) => (
              <div className="dbo-card" key={order._id}>
                {/* Head */}
                <div className="dbo-card-head">
                  <div>
                    <div className="dbo-order-no">Order #{order._id.slice(-6).toUpperCase()}</div>
                    <div className="dbo-order-date">{new Date(order.createdAt).toLocaleString()}</div>
                  </div>
                  {statusPill(order.orderStatus)}
                </div>

                {/* Body */}
                <div className="dbo-card-body">
                  <div className="dbo-detail-row">
                    <span className="dbo-detail-icon">👤</span>
                    <div>
                      <div className="dbo-detail-label">Customer</div>
                      <div className="dbo-detail-val">{order.first_name} {order.last_name}</div>
                    </div>
                  </div>
                  <div className="dbo-detail-row">
                    <span className="dbo-detail-icon">📞</span>
                    <div>
                      <div className="dbo-detail-label">Phone</div>
                      <div className="dbo-detail-val"><a href={`tel:${order.phone_number}`}>{order.phone_number}</a></div>
                    </div>
                  </div>
                  <div className="dbo-detail-row">
                    <span className="dbo-detail-icon">📍</span>
                    <div>
                      <div className="dbo-detail-label">Delivery Address</div>
                      <div className="dbo-detail-val">{order.address}, {order.city}</div>
                    </div>
                  </div>

                  {order.orderItems?.length > 0 && (
                    <div className="dbo-detail-row">
                      <span className="dbo-detail-icon">📦</span>
                      <div>
                        <div className="dbo-detail-label">Items ({order.orderItems.length})</div>
                        <div className="dbo-items-list">
                          {order.orderItems.slice(0, 3).map((item, i) => (
                            <span key={i} className="dbo-item-chip">
                              {item.product?.title || `Item ${i + 1}`}
                            </span>
                          ))}
                          {order.orderItems.length > 3 && (
                            <span className="dbo-item-chip">+{order.orderItems.length - 3} more</span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Footer */}
                {order.orderStatus !== "delivered" && (
                  <div className="dbo-card-footer">
                    {order.orderStatus === "assigned" && (
                      <button className="dbo-btn dbo-btn-primary" onClick={() => handleAccept(order._id)}>
                        🚛 Accept Order
                      </button>
                    )}
                    {order.orderStatus === "active" && (
                      <button
                        className="dbo-btn dbo-btn-success"
                        onClick={() => handleDeliver(order._id)}
                      >
                        {confirmId === order._id ? "⚡ Tap again to confirm!" : "✅ Mark as Delivered"}
                      </button>
                    )}
                    <a
                      href={`https://maps.google.com?q=${encodeURIComponent((order.address || "") + " " + (order.city || ""))}`}
                      target="_blank" rel="noreferrer"
                      className="dbo-btn dbo-btn-ghost"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", textDecoration: "none" }}
                    >
                      🗺️ Map
                    </a>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
      <FooterB assignedOrderCount={counts.pending + counts.active} />
    </>
  );
};

export default Orders;
